import { render, staticRenderFns } from "./AreaAdd.vue?vue&type=template&id=17f338da"
import script from "./AreaAdd.vue?vue&type=script&lang=ts"
export * from "./AreaAdd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports